import {connect} from "react-redux"
import {breakpoints} from "@next/ux-fabric"
import {getUpperHeaderHeight} from "../../utils/getHeaderHeight"
import State from "../../ducks/state"
import {SupportedRegionTypes} from "../../models/regions"
import checkBannerVisibility from "../../utils/checkBannerVisibility"

export const mapStateToProps = (state: State) => {
    const {template, showStaticHeaderBanner, enableContentBanner, isCountrySelectorInGlobalAppBar} = state.settings
    const isAutocompleteEnabled = state.settings.autocompleteEnabled
    const showAutoComplete = isAutocompleteEnabled && state.search.showAutocomplete
    const {showRecentSearch} = state.search

    const messageBannerControls: any = state.data?.regions.find(
        region => region.type === SupportedRegionTypes.MessageBanner,
    )
    const bannerVisibility = checkBannerVisibility(
        state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)?.elements,
        enableContentBanner,
        state.request.url,
        messageBannerControls?.enabled,
        showStaticHeaderBanner,
        (typeof window !== "undefined" && window.innerWidth > breakpoints.values.md) || true, // Default to true for SSR
        isCountrySelectorInGlobalAppBar,
    )
    // upperheader does not need back-to-site banner height as the banner sits outside of the header.
    const headerHeights = getUpperHeaderHeight(
        template,
        bannerVisibility.showaAppBar,
        bannerVisibility.showCMSBanner,
        false,
    )
    return {
        mobileHeight: headerHeights.mobile,
        desktopHeight: headerHeights.desktop,
        showAutoComplete,
        showRecentSearch,
    }
}

export default connect(mapStateToProps)
